export default __webpack_public_path__ + "static/1375-43e2e10b09cf36bd03184e31ef259a57.gif";